<template>
    <div>
        <page-title>站点管理</page-title>
        <page-body>
            <list-header>
                <div>
                    <router-link to="/dashboard/admin/host/auth-warning">授权警告</router-link>
                </div>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0; max-width: 100px; margin-right: 0">
                                <el-select v-model="time" size="mini" placeholder="时间类型">
                                    <el-option v-for="item in timeOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; margin-top: 1px">
                                <el-date-picker
                                        size="mini"
                                        @change="dateChange"
                                        v-model="date"
                                        type="datetimerange"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 80px">
                                <el-select v-model="status" clearable size="mini" placeholder="状态" @change="search()">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 80px">
                                <el-select v-model="type" clearable size="mini" placeholder="版本" @change="search()">
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="名称/域名/服务器IP/备案主体"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="name" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                        <div style="font-size: 12px;color: #909090">{{scope.row.name}}</div>
                        <template v-if="scope.row.mchUser">
                            <div style="font-size: 12px;color: #909090">商盟: {{scope.row.mchUser.name}}</div>
                        </template>
                        <template v-else>
 							<div style="font-size: 12px;color: #909090">备案主体: {{scope.row.subject}}</div>
                            <div style="font-size: 12px;color: #909090">用户: {{scope.row.user.name}}</div>
                            <div style="font-size: 12px;color: #909090">M: {{scope.row.user.mobile}}, Q:
                                {{scope.row.user.qq}}
                            </div>
                        </template>
                        <div style="font-size: 12px;color: #909090" v-if="scope.row.log && scope.row.log.user && scope.row.log.user.name">授权人: {{scope.row.log.user.name}}</div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                    </template>
                </el-table-column>
                <el-table-column prop="domain" label="服务器IP" width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.row.hostIps.length > 10">
                            <div v-for="(item, index) in scope.row.hostIps" :key="item.id" v-if="index < 10">
                                {{item.ip}}
                            </div>
                            <el-button type="text" style="padding: 0;" @click="showAllIps(scope.row.hostIps)">更多...
                            </el-button>
                        </template>
                        <template v-else>
                            <div v-for="item in scope.row.hostIps" :key="item.id">{{item.ip}}</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="授权状态" width="100">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.status===0">审核中</span>
                        <span style="color: #67C23A" v-else-if="scope.row.status===1">已授权</span>
                        <br>
                        <template v-for="(item, index) in scope.row.appOrders">
                            <span style="color: #ff4544;display: inline-block" v-if="item.is_forever === 0 && item.diff_date > 0 && item.diff_date <= 30 ">{{item.app.display_name}}还差{{item.diff_date}}天到期</span>
                            <span style="color: #ff4544;display: inline-block" v-else-if="item.is_forever === 0 && item.diff_date < 0">{{item.app.display_name}}已过期{{Math.abs(item.diff_date)}}天</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="版本" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_year==2">年费版</div>
                        <template v-if="scope.row.type === 1">
                            <div>微擎版</div>
                            <div v-if="scope.row.we7_branch===1">自运营版</div>
                            <div v-if="scope.row.we7_branch===2">无限开版</div>
                        </template>
                        <template v-if="scope.row.type === 2">
                            <div>独立版</div>
                            <div>
                                <span>子账户: </span>
                                <span v-if="scope.row.account_num === -1">无限制</span>
                                <span v-else>{{scope.row.account_num}}个</span>
                            </div>
                            <div>
                                <span>小程序: </span>
                                <span v-if="scope.row.app_count === -1">无限制</span>
                                <span v-else>{{scope.row.app_count}}个</span>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间" width="160">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="添加时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                        </el-tooltip>
                        <el-tooltip class="item" content="更新时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="应用">
                    <template slot-scope="scope">
                        <template v-if="scope.row.appOrdersCount">
                            <router-link :to="'/dashboard/admin/app-order/index?host_id=' + scope.row.id">
                                {{scope.row.appOrdersCount.value}}
                            </router-link>
                        </template>
                        <template v-else>0</template>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <el-button type="text" v-if="scope.row.status === 0" @click="updateStatus(scope.row, 1)">
                                授权通过
                            </el-button>
                            <el-button type="text" v-else @click="updateStatus(scope.row, 0)">取消授权</el-button>
                            <span class="text-split">|</span>
                            <router-link :to="'/dashboard/admin/host/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="deleteHost(scope.row)">删除</el-button>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="clearHost(scope.row)">清除限制</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .list-header {
            padding: 0.5rem 0.2rem;
        }
    }
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    components: {
        'HostTest': () => import('@/components/HostTest.vue'),
        'ViewCertificate': () => import('@/components/ViewCertificate.vue')
    },
    data() {
        return {
            showHostTestDialog: false,
            statusOptions: [
                {
                    value: 0,
                    label: '未授权'
                },
                {
                    value: 1,
                    label: '已授权'
                },
                {
                    value: 2,
                    label: '年费到期'
                },
                {
                    value: 3,
                    label: '即将到期'
                }
            ],
            typeOptions: [
                {
                    value: 1,
                    label: '微擎版'
                },
                {
                    value: 2,
                    label: '独立版'
                }
            ],
            loading: false,
            list: null,
            pagination: null,
            status: null,
            type: null,
            keyword: '',
            user_id: null,
            date: null,
            start_at: null,
            end_at: null,
            time: 1,
            timeOptions: [
                {
                    value: 1,
                    label: '更新时间'
                },
                {
                    value: 3,
                    label: '到期时间'
                }
            ]
        }
    },
    created() {
        this.user_id = this.$route.query.user_id || null
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            if (this.date) {
                this.start_at = this.date[0]
                this.end_at = this.date[1]
            } else {
                this.start_at = null
                this.end_at = null
            }
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/host/index',
                    params: {
                        page: page,
                        status: this.status,
                        type: this.type,
                        keyword: this.keyword,
                        user_id: this.user_id,
                        start_at: this.start_at,
                        end_at: this.end_at,
                        time: this.time
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        showAllIps(ips) {
            let content = ''
            for (let i in ips) {
                content += `<div>${ips[i].ip}</div>`
            }
            this.$alert(content, '服务器IP', {
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
            })
        },
        deleteHost(host) {
            new Promise(resolve => {
                this.$confirm('此操作将删除该站点, 是否继续?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(host)
                }).catch(() => {
                })
            }).then(host => {
                this.loading = true
                axios({
                    url: 'admin/host/delete',
                    params: {
                        id: host.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        host.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        updateStatus(host, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认取消授权？'
            } else {
                content = '是否确认授权通过？'
            }
            this.$confirm(content, '提示', {}).then(() => {
                const data = helper.clone(host)
                data.status = status
                data['host_ip_list'] = host.hostIps
                delete data.hostIps
                this.loading = true
                axios({
                    url: 'admin/host/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        host.status = status
                        this.$message.success('操作成功。')
                    } else {
                        host.status = status === 0 ? 1 : 0
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        },
        dateChange() {
            this.loadData(0)
        },
        clearHost(host) {
            new Promise(resolve => {
                this.$confirm('此操作将清除站点的更新限制, 是否继续?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(host)
                }).catch(() => {
                })
            }).then(host => {
                this.loading = true
                axios({
                    url: 'admin/host/clear',
                    params: {
                        id: host.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        }
    }
}
</script>
